<template>
  <div class="border-box row">
    <div class="col-12 col-xl-10 offset-xl-1">
      <div class="import-path">
        <div class="row text-center">
          <div class="col-12 my-4 my-lg-5 text-bold text-24"> {{ $t('flexben.import.greetings_question') }}</div>
        </div>
        <div class="row">
          <template v-for="entry in orderedImportTypesAccess">

            <div v-if="shouldRender(entry.obj, entry.key)" class="col-md-6 mt-2 mb-md-4" :key="entry.key">
              <button class="btn import-options d-inline-flex" @click="choseImport(entry.key)"
                      :disabled="!entry.obj.enable">
                  <font-awesome-icon :icon="getFaImportIcon(entry.key)" style="min-width: 45px" class="fa-fade text-themed mr-4 ml-2 float-left my-auto fa-2x "  />
                  <span class="my-auto text-uppercase text-line-h-1">{{ $t('flexben.import.buttons.chose_'+entry.key) }}</span>
                  <font-awesome-icon v-if="entry.key === 'budgets_auto' || entry.key === 'time_sheets_auto' " icon="clock" class="text-themed-dark fa-spin ml-2 text-right float-right my-auto fa-1x " />
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChoseImportType",
  props: {
    isAdmin: {
      type: Boolean,
      required: true
    },
    importTypesAccess: {
      type: Object,
      required: true,
      default: function () {
        return {
          beneficiaries: false,
          budgets: false,
          time_sheets: false,
          budget_auto: false,
          budgets_auto: false,
          time_sheets_auto: false,
          telework_budgets: false,
          ppp3: false,
        };
      }
    }
  },
  computed: {
    orderedImportTypesAccess() {
      const entries = Object.entries(this.importTypesAccess).map(([key, obj]) => ({key, obj}));
      return [
        ...entries.filter((entry) => entry.key !== 'budget_auto'),
        ...entries.filter((entry) => entry.key === 'budget_auto')
      ];
    }
  },
  methods: {
    shouldRender(obj, key) {
      if (this.isAdmin === false && key === 'ppp3') {
        return false;
      }
      return obj.show;
    },
    choseImport(type) {
      this.$emit('choseImport', type)
    },
    getFaImportIcon(key) {

      switch (key) {
        case "beneficiaries":
        case "offer_beneficiaries":
          return 'user-plus';
        case "update_beneficiaries":
          return 'user-edit';
        case "budgets":
        case "telework_budgets":
          return 'money-bill';
        case "budgets_auto":
          return 'money-bill-wave';
        case "time_sheets":
          return 'calendar-check';
        case "time_sheets_auto":
          return 'calendar-alt';
        case "ppp3":
          return 'suitcase';
        default:
          return "bug";
      }
    }
  }
}
</script>
